import { UserPersonalDetails } from './types'

export function mapPersonalDetailsResponse(data: any): UserPersonalDetails {
  return {
    ...data,
    email: data.email,
    address: data.address ? data.address : undefined,
    birthDate: data.birthDate ? data.birthDate : undefined,
    carRegistrationNumber: data.carRegistrationNumber
      ? data.carRegistrationNumber
      : undefined,
    city: data.city ? data.city : undefined,
    county: data.county ? data.county : undefined,
    postcode: data.postcode ? data.postcode : undefined,
    telephone: getTelephoneData(data.telephone),
  }
}

function getTelephoneData(telephone: any): UserPersonalDetails['telephone'] {
  const countryDialingCode = telephone?.countryDialingCode
    ? telephone.countryDialingCode
    : ''
  const countryDialingNumber = telephone?.countryDialingNumber
    ? telephone.countryDialingNumber
    : ''
  return {
    ...telephone,
    countryDialingCode,
    countryDialingNumber,
  }
}
